import React from 'react';
import { MotionConfig } from 'framer-motion';
import { Hero } from './components/Hero';
import { DailyMoment } from './components/DailyMoment';
import { Problem } from './components/Problem';
import { DayPath } from './components/DayPath';
import { Gallery } from './components/Gallery';
import { RosaryBonus } from './components/RosaryBonus';
import { StartAnytime } from './components/StartAnytime';
import { Pricing } from './components/Pricing';
import { Closing } from './components/Closing';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
import { useMetaPixel } from './hooks/useMetaPixel';
interface AppProps {
  showPurchaseNotifications?: boolean;
}
export function App({
  showPurchaseNotifications = true
}: AppProps) {
  useMetaPixel();
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="23vuoyeelqyvo">
      <div className="w-full bg-cream" data-id="element-1" data-mp="23ut97wmn5o7m">
        <main data-id="element-2" data-mp="3ik7gwiph6frp">
          <Hero data-id="element-3" data-mp="3ikh9me1wn113" />
          <DailyMoment data-id="element-4" data-mp="3iiwfuqnezm4a" />
          <Problem data-id="element-5" data-mp="3ijpcgysnsv8p" />
          <DayPath data-id="element-6" data-mp="3ii4ro0w5cqo1" />
          <Gallery data-id="element-7" data-mp="3mlax56bfqdtg" />
          <RosaryBonus data-id="element-8" data-mp="3mkrgdsxitvh0" />
          <StartAnytime data-id="element-9" data-mp="3mjzuj9tq7c3x" />
          <Pricing data-id="element-10" data-mp="3mj6ipufwtwex" />
          <Closing data-id="element-11" data-mp="3rcj6k2crlz6m" />
          <Guarantee data-id="element-12" data-mp="3rbzo8kj7d8s2" />
          <Faq data-id="element-13" data-mp="3rdkkqfp2v1sk" />
        </main>
        <Footer data-id="element-14" data-mp="3reltgdimfc74" />
        {showPurchaseNotifications && <PurchaseToast data-id="element-15" data-mp="4wvvprmowg9" />}
      </div>
    </MotionConfig>;
}